import axios from 'axios'

const voicebotAxios = axios.create({
  baseURL: process.env.VUE_APP_VOICEBOT_URL || 'http://localhost:3003',
  headers: {
    'Content-Type': 'application/json',
  },
})

export default voicebotAxios
